import { mapState, mapActions } from 'vuex'
import { fabric } from 'fabric'
import { STORE_KEY, KEY_SHAPE, KEY_TXT, KEY_PICTURE, BASE_64_DEFINE, MEDIA_TYPE_IMG, MEDIA_TYPE_VIDEO, MEDIA_TYPE_AUDIO, KEY_VIDEO, KEY_AUDIO } from './constants'
import { APP_CONFIG } from '@/utils/constants'
import fileService from './../_api/fileService'

const posterVideo = `${APP_CONFIG.cdnLive}/img/playresize.svg` //require('@/assets/images/linktypes/playresize.svg')
const posterAudio =  `${APP_CONFIG.cdnLive}/img/audioresize40.svg` // require('@/assets/images/linktypes/audioresize40.svg')

export default {
  data () {
    return {
      slideObj: null,
      copiedObject: {},
      copiedObjects: [],
      baseUrl: APP_CONFIG.appUrl,
      bookCdnUrl: APP_CONFIG.bookCdnUrl
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['slideCurr', 'slidesMain', 'slideIndexVisible']),
    lessonId () {
      return parseInt(this.$route.params.id)
    }
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetSlidesMain', 'acSetSlideCurr', 'acSetLinkAudioVieoViewer']),

    // async setDataSaved2 (sizeCurr) {
    //   if (this.slideIndexVisible > -1) {
    //     // console.log('AAAAAAAAAAA: ', this.slidesMain[this.slideIndexVisible])
    //     await this.slideCurr.loadFromJSON(this.slidesMain[this.slideIndexVisible].jsonValue)
    //     // console.log('VOVO', this.slidesMain)
    //     this.setResizeElms(sizeCurr)
    //   }
    // },

    // setResizeElms (sizeCurr) {
    //   console.log('Resize: ', this.slideCurr._objects)
    //   let self = this
    //   if (self.slideCurr._objects && self.slideCurr._objects.length > 0) {
    //     let lengthObjs = self.slideCurr._objects.length
    //     self.slideCurr._objects.map(async (item, index) => {
    //       await self.calSizeElsCanvas(item, sizeCurr)

    //       self.slidesMain[self.slideIndexVisible]['items'][index] = item
    //       if (index === lengthObjs - 1) {
    //         self.slideCurr.renderAll().trigger('selection:cleared')
    //       }
    //     })
    //   }
    // },

    setDataSaved (sizeCurr = null) {
      let self = this
      // let sizeCurr = this.getClientSizeAddEl()
      self.slideCurr && self.slideCurr.clear()
      // console.log('Set data saved: ', this.slideIndexVisible, this.slidesMain[this.slideIndexVisible].items, this.slideCurr.objects)
      if (this.slidesMain[this.slideIndexVisible] && this.slidesMain[this.slideIndexVisible].items && this.slidesMain[this.slideIndexVisible].items.length > 0) {
        this.slidesMain[this.slideIndexVisible].items.map(async (item, index) => {
          // console.log('Index setdatasave: ', index)
          await self.calSizeElsCanvas(item, sizeCurr)
          // console.log('Check object set: ', index, item)
          // Key 'item.aCoords' is check fabric object
          if (this.lessonId > 0 && !item.aCoords) {
            switch(item.type) {
              case 'IText':
                // item = !item.aCoords ? new fabric.IText(item.text, {...item}) : item
                item = new fabric.IText(item.text, {...item})
                break;
              case 'Group':
                let objGroup = []
                item.objects.map(obj => {
                  if (obj.type === 'Line') {
                    let points = [obj.x1, obj.y1, obj.x2, obj.y2]
                    objGroup.push( new fabric.Line(points, {...obj}) )
                  } else {
                    objGroup.push(new fabric[obj.type]({...obj}))
                  }
                })
                item = new fabric.Group(objGroup, {...item})
                break;
              case 'Polygon':
                item = new fabric.Polygon(item.points, {...item})
                break;
              case 'Line':
                let points = [item.x1, item.y1, item.x2, item.y2]
                item = new fabric.Line(points, {...item})
                break;
              case KEY_PICTURE:
                self.addImageUrl(item.src, {...item})
                break;
              case KEY_VIDEO:
                self.addVideo({...item}, true)
                break;
              case KEY_AUDIO:
                self.addAudio({...item}, true)
                break;
              default:
                item = new fabric[item.type]({...item})
                break;
            }
          }

          if (self.slidesMain[self.slideIndexVisible].backgroundImage) {
            self.setBgSlide(self.slidesMain[self.slideIndexVisible].backgroundImage)
          }

          if ( ![KEY_PICTURE, KEY_VIDEO, KEY_AUDIO].includes(item.type) || this.lessonId === 0 || item.aCoords){
            self.slideCurr.add(item)
            // self.slideCurr.trigger('object:modified')
          }
        })
      } else if (self.slidesMain[self.slideIndexVisible] && self.slidesMain[self.slideIndexVisible].backgroundImage) {
        // console.log('Set background for slide: ', self.slidesMain[self.slideIndexVisible].background_slide)
        self.setBgSlide(self.slidesMain[self.slideIndexVisible].backgroundImage)
      }
    },

    setBgSlide (url) {
      let self = this
      const optionReq = {
        crossOrigin: 'anonymous',
        type: KEY_PICTURE,
        type_detail: KEY_PICTURE,
        position: self.slidesMain[self.slideIndexVisible].items.length,
        ...self.handleConvertDimensions2PercentObj({top: 0, left: 0})
      }
      fabric.Image.fromURL(url, function(img) {
        // img.set({ 'left': 0 });
        // img.set({ 'top': 0 });
        // img.scaleToWidth(self.slideCurr.width / img.width);
        // img.scaleToHeight(self.slideCurr.height / img.height);
        // add background image
        self.slideCurr.setBackgroundImage(img, self.slideCurr.renderAll.bind(self.slideCurr), {
          scaleX: self.slideCurr.width / img.width,
          scaleY: self.slideCurr.height / img.height
        });
        // self.handleAddNewAndTrigger(img)
      }, optionReq);
      self.slidesMain[self.slideIndexVisible]['backgroundImage'] = url
      // self.acSetSlidesMain([...self.slideIndexVisible])
    },

    getClientSizeAddEl () {
      let canvasEl = document.getElementById('slide_main')
      if (canvasEl) {
        return {
          width: canvasEl.clientWidth,
          height: canvasEl.clientHeight
        }
      }
    },

    handleConvertDimensions2PercentObj (dimension = null) {
      let layout = this.getClientSizeAddEl()
      var objectWorking = dimension || this.slideCurr.getActiveObject()
      // console.log('OBJECT WORKING: ', objectWorking);
      let result = {
        layout
        // dimensions_percent: {
        //   top: this.convertDataXToPercent(objectWorking.top, layout.height),
        //   left: this.convertDataXToPercent(objectWorking.left, layout.width)
        // }
      }
      // if (objectWorking.width) {
      //   result.dimensions_percent.width = this.convertDataXToPercent(objectWorking.width, layout.width)
      // }
      // if (objectWorking.height) {
      //   result.dimensions_percent.height = this.convertDataXToPercent(objectWorking.height, layout.height)
      // }
      // if (objectWorking.rx) {
      //   result.dimensions_percent.rx = this.convertDataXToPercent(objectWorking.rx, layout.width)
      // }
      // if (objectWorking.ry) {
      //   result.dimensions_percent.ry = this.convertDataXToPercent(objectWorking.ry, layout.height)
      // }
      return result
    },

    convertDataXToPercent(val, widthLayout) {
      return (val/widthLayout)*100;
    },

    convertDataYToPercent(val, heightLayout) {
      return (val/heightLayout)*100;
    },

    convertDataXToPX(val, widthLayout) {
      return (val/100)*widthLayout;
    },

    convertDataYToPX(val, heightLayout) {
      return (val/100)*heightLayout;
    },

    calSizeElsCanvas (item, sizeCurr) {
      // let sizeCurr = await this.getClientSizeAddEl()
      // console.log('Cal size:', sizeCurr)
      if (item.layout && sizeCurr && item.layout.width !== sizeCurr.width) {
        let perWidth = (sizeCurr.width/item.layout.width)
        let perHeight = (sizeCurr.height/item.layout.height)
        // console.log('Perwidth: ', perWidth, perHeight, sizeCurr, item.layout, item.width, item.height, item.left, item.top, item.scaleX, item.scaleY)
        item.layout.height = sizeCurr.height
        item.layout.width = sizeCurr.width

        item.scaleX *= perWidth
        item.scaleY *= perHeight

        item.left *= perWidth
        item.top *= perHeight
        // item.left = this.convertDataXToPX(item.left, sizeCurr.width)
        // item.top = this.convertDataYToPX(item.top, sizeCurr.height)
        // if (item.type !== 'IText') {
        //   // return;
        //   // item.width *=perWidth
        //   // item.height *= perHeight
        //   // item.width = this.convertDataXToPX(item.width, sizeCurr.width)
        //   // item.height = this.convertDataYToPX(item.height, sizeCurr.height)
        // }

        // console.log('Perwidth Done: ', perWidth, perHeight, sizeCurr, item.layout, item.width, item.height, item.left, item.top, item.scaleX, item.scaleY)
        // this.slideCurr.renderAll().trigger('selection:cleared')
        // this.slideCurr.setZoom(this.slideCurr.getZoom()*perWidth)
        // canvas.setZoom(canvas.getZoom()*SCALE_FACTOR);
        // item.width *=perWidth
        // item.height *= perHeight
        // item.setCoords()
        // console.log('Call item: ', item);
      }
    },

    changeStyleForArea (name, value) {
      var object = this.slideCurr.getActiveObject();
      if (!object) return;
      // console.log('change style of obj: ', object, object.width)
      object.set(name, value).setCoords();
      this.slideCurr.renderAll();
      this.handleSaveCanvas()
    },
    
    handleSaveCanvas () {
      this.saveToImage()
      this.saveToSVG()
      let jsonValue = this.saveToJson()
      this.slidesMain[this.slideIndexVisible]['jsonValue'] = jsonValue
      this.acSetSlidesMain([...this.slidesMain])
    },

    changeColor (val) {
      this.changeStyleForArea('fill', val)
    },

    saveToSVG () {
      let canvasImg = this.slideCurr.toSVG();
      this.slidesMain[this.slideIndexVisible].imageSvg = canvasImg
      return canvasImg;
    },

    saveToJson () {
      return JSON.stringify(this.slideCurr.toJSON());
    },

    saveToImage () {
      let imgBase64 = this.slideCurr.toDataURL({ format: 'png' });
      this.slidesMain[this.slideIndexVisible].imageBase64 = imgBase64.replace(BASE_64_DEFINE, '')
      return imgBase64;
    },

    copy () {
      this.copiedObjects = [];
      if(this.slideCurr.getActiveObject()){
        this.copiedObject = fabric.util.object.clone(this.slideCurr.getActiveObject());
        this.copiedObjects = [];
      } else if(this.slideCurr.getActiveGroup()){
        //console.log(this.slideCurr.getActiveGroup().getObjects());
        this.slideCurr.getActiveGroup().getObjects().forEach(function(o){
            var object = fabric.util.object.clone(o);
            this.copiedObjects.push(object);
        });             
      }
    },

    paste () {
      if(this.copiedObjects.length > 0){
        for(var i in this.copiedObjects){
          this.copiedObjects[i]= fabric.util.object.clone(this.copiedObjects[i]);
      
          this.copiedObjects[i].set("top", this.copiedObjects[i].top+100);
          this.copiedObjects[i].set("left", this.copiedObjects[i].left+100);
          
          this.slideCurr.add(this.copiedObjects[i]);
          this.slideCurr.item(this.slideCurr.size() - 1).hasControls = true;
        }
      } else if(this.copiedObject){
        this.copiedObject = fabric.util.object.clone(this.copiedObject);
        this.copiedObject.set("top", 150);
        this.copiedObject.set("left", 150);
        this.slideCurr.add(this.copiedObject);
        this.slideCurr.item(this.slideCurr.size() - 1).hasControls = true;
        this.slidesMain[this.slideIndexVisible].items.push(this.copiedObject)
      }
      this.slideCurr.renderAll();  
    },

    addNewTxt (valSaved = null) {
      let textDefault = valSaved ? valSaved.text : 'Double click to edit.'
      let dataTxtNew = valSaved ? valSaved : {
        type: 'IText',
        type_detail: KEY_TXT,
        left: 100,
        top: 100,
        originX: "left",
        originY: "top",
        fontFamily: this.fontActive,
        fontSize: 16,
        ...this.handleConvertDimensions2PercentObj({top: 100, left: 100})
      }

      let dataTxt = new fabric.IText(textDefault, dataTxtNew)
      this.handleAddNewAndTrigger(dataTxt, valSaved)
    },

    addShape (val, valSaved = null) {
      let self = this
      self.shapeChoosed = val
      switch (val) {
        case 'rect':
          this.addRect(val, valSaved)
          break;
        case 'rectangle-1':
          this.addRectangle1(val, valSaved)
          break;
        case 'rec-corner':
          this.addRectCornor(val, valSaved)
          break;
        case 'parallelogram':
          this.addRectParallelogram(val, valSaved)
          break;
        case 'triangle':
          this.addTriangle(val, valSaved)
          break;
        case 'triangle-2':
          this.addTriangle2(val, valSaved)
          break;
        case 'rhombus':
          this.addRectRhombus(val, valSaved)
          break;
        case 'circle':
          this.addCircle(val, valSaved)
          break;
        case 'ellipse':
          this.addEllipse(val, valSaved)
          break;
        case 'pentagon':
          this.addPolygon5(val, valSaved)
          break;
        case 'trapezoid':
          this.addTrapezoid(val, valSaved)
          break;
        case 'hexagon':
          this.addHexagon(val, valSaved)
          break;
      }
    },

    addShapeLine (val, valSaved = null) {
      this.lineShapeChoosed = val
      switch (val) {
        case 'line-1':
          this.addLine(val, valSaved)
          break;
        case 'line-2':
          this.addLine(val, true, valSaved)
          break;
        case 'line-3':
          this.addArrowLine(val, valSaved)
          break;
        case 'line-4':
          this.addArrowLine(val, true, valSaved)
          break;
        case 'line-5':
          this.addArrowLine(val, false, true, valSaved)
          break;
        case 'line-6':
          this.addArrowLine(val, true, true, valSaved)
          break;
        case 'line-7':
          this.addLineCircle(val, valSaved)
          break;
        case 'line-8':
          this.addLineCircle(val, true, valSaved)
          break;
      }
    },

    addShapeArrow (val, valSaved = null) {
      this.arrowShapeChoosed = val
      switch (val) {
        case 'arrow-l':
          this.addArrowShape(val, 180, valSaved)
          break;
        case 'arrow-r':
          this.addArrowShape(val, valSaved)
          break;
        case 'arrow-d':
          this.addArrowShape(val, 90, valSaved)
          break;
        case 'arrow-u':
          this.addArrowShape(val, -90, valSaved)
          break;
        case 'arrow-2':
          this.addArrowShape(val, 0, true, valSaved)
          break;
      }
    },

    addRect (val, valSaved) {
      let dataRect = valSaved ? valSaved : {
        type: 'Rect',
        // type_detail: val,
        type_detail: val,
        top: 50,
        left: 20,
        width: 100,
        height: 100,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        fill: this.colorFillCurr,
        originX: "left",
        originY: "top",
        centeredRotation: !0,
        stroke: this.colorFillCurr,
        strokeWidth: 1,
        ...this.handleConvertDimensions2PercentObj({top: 50, left: 50, width: 100, height: 100})
      }
      let rect = new fabric.Rect(dataRect)
      this.handleAddNewAndTrigger(rect)
    },

    addRectangle1 (val, valSaved) {
      let dataRect = valSaved ? valSaved : {
        type: 'Rect',
        type_detail: val,
        top: 50,
        left: 100,
        width: 100,
        height: 100,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        fill: this.colorFillCurr,
        originX: "left",
        originY: "top",
        centeredRotation: !0,
        stroke: this.colorFillCurr,
        strokeWidth: 1,
        rx: 10,
        ry: 10,
        skewX: -10,
        ...this.handleConvertDimensions2PercentObj({top: 50, left: 100, width: 100, height: 100})
        // angle: 45,
        // scaleX: 3,
        // scaleY: 3
      }
      let rect = new fabric.Rect(dataRect)
      this.handleAddNewAndTrigger(rect)
    },

    addRectParallelogram (val, valSaved) {
      let dataRect = valSaved ? valSaved : {
        type: 'Rect',
        type_detail: val,
        top: 50,
        left: 100,
        width: 100,
        height: 100,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        fill: this.colorFillCurr,
        originX: "left",
        originY: "top",
        centeredRotation: !0,
        stroke: this.colorFillCurr,
        strokeWidth: 1,
        skewX: -10,
        ...this.handleConvertDimensions2PercentObj({top: 50, left: 100, width: 100, height: 100})
      }
      let rect = new fabric.Rect(dataRect)
      this.handleAddNewAndTrigger(rect)
    },

    addRectCornor (val, valSaved) {
      let dataRect = valSaved ? valSaved : {
        type: 'Rect',
        type_detail: val,
        top: 50,
        left: 100,
        width: 100,
        height: 100,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        fill: this.colorFillCurr,
        originX: "left",
        originY: "top",
        centeredRotation: !0,
        stroke: this.colorFillCurr,
        strokeWidth: 1,
        rx: 10,
        ry: 10,
        ...this.handleConvertDimensions2PercentObj({top: 50, left: 100, width: 100, height: 100})
      }
      let rect = new fabric.Rect(dataRect)
      this.handleAddNewAndTrigger(rect)
    },

    addRectRhombus (val, valSaved) {
      let dataRect = valSaved ? valSaved : {
        type: 'Rect',
        type_detail: val,
        top: 50,
        left: 100,
        width: 100,
        height: 100,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        fill: this.colorFillCurr,
        originX: "left",
        originY: "top",
        centeredRotation: !0,
        stroke: this.colorFillCurr,
        strokeWidth: 1,
        angle: 45,
        ...this.handleConvertDimensions2PercentObj({top: 50, left: 100, width: 100, height: 100})
      }
      let rect = new fabric.Rect(dataRect)
      this.handleAddNewAndTrigger(rect)
    },

    addTriangle (val, valSaved) {
      let dataTriangle = valSaved ? valSaved : {
        type: 'Triangle',
        type_detail: val,
        top: 50,
        left: 100,
        width: 160,
        height: 120,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        fill: this.colorFillCurr,
        stroke: this.colorFillCurr,
        strokeWidth: 1,
        ...this.handleConvertDimensions2PercentObj({top: 50, left: 100, width: 160, height: 120})
      }
      let rect = new fabric.Triangle(dataTriangle)
      this.handleAddNewAndTrigger(rect)
    },

    addTriangle2 (val, valSaved) {
      let dataTriangle = valSaved ? valSaved : {
        type: 'Triangle',
        type_detail: val,
        top: 50,
        left: 100,
        width: 160,
        height: 120,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        fill: this.colorFillCurr,
        stroke: this.colorFillCurr,
        strokeWidth: 1,
        skewX: 35,
        ...this.handleConvertDimensions2PercentObj({top: 50, left: 100, width: 160, height: 120})
      }
      let rect = new fabric.Triangle(dataTriangle)
      this.handleAddNewAndTrigger(rect)
    },

    addCircle (val, valSaved) {
      let dataCircle = valSaved ? valSaved : {
        type: 'Circle',
        type_detail: val,
        top: 50,
        left: 100,
        width: 100,
        height: 100,
        radius: 50,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        fill: this.colorFillCurr,
        stroke: this.colorFillCurr,
        strokeWidth: 1,
        ...this.handleConvertDimensions2PercentObj({top: 50, left: 100, width: 100, height: 100})
      }
      let circle = new fabric.Circle(dataCircle)
      this.handleAddNewAndTrigger(circle)
    },

    addEllipse (val, valSaved) {
      let dataEllipse = valSaved ? valSaved : {
        type: 'Ellipse',
        type_detail: val,
        top: 50,
        left: 100,
        width: 160,
        height: 120,
        radius: 30,
        rx: 40, 
        ry: 80,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        fill: this.colorFillCurr,
        stroke: this.colorFillCurr,
        strokeWidth: 1,
        ...this.handleConvertDimensions2PercentObj({top: 50, left: 100, width: 160, height: 120, rx: 40, ry: 80})
      }
      let ellipse = new fabric.Ellipse(dataEllipse)
      this.handleAddNewAndTrigger(ellipse)
    },

    addPolygon5 (val, valSaved) {
      let points = [
        { x: 200, y: 10 }, 
        { x: 250, y: 50 }, 
        { x: 240, y: 105}, 
        { x: 160, y: 105}, 
        { x: 150, y: 50 }
      ]
      let dataPolygon = valSaved ? valSaved : {
        type: 'Polygon',
        type_detail: val,
        top: 50,
        left: 50,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        fill: this.colorFillCurr,
        stroke: this.colorFillCurr,
        strokeWidth: 1,
        objectCaching: false,
        transparentCorners: false,
        layout: this.getClientSizeAddEl()
      }
      let ellipse = new fabric.Polygon(points, dataPolygon)
      this.handleAddNewAndTrigger(ellipse)
    },

    addTrapezoid (val, valSaved) {
      let points = [
        { x: 200, y: 50 },
        { x: 220, y: 105},
        { x: 120, y: 105},
        { x: 140, y: 50 }
      ]
      let dataPolygon = valSaved ? valSaved : {
        type: 'Polygon',
        type_detail: val,
        top: 50,
        left: 50,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        fill: this.colorFillCurr,
        stroke: this.colorFillCurr,
        strokeWidth: 1,
        objectCaching: false,
        transparentCorners: false,
        ...this.handleConvertDimensions2PercentObj({top: 50, left: 50})
      }
      let ellipse = new fabric.Polygon(points, dataPolygon)
      this.handleAddNewAndTrigger(ellipse)
    },

    addHexagon (val, valSaved) {
      let points = [
        { x: 150, y: 50 },
        { x: 200, y: 50 },
        { x: 225, y: 90},
        { x: 200, y: 130 },
        { x: 150, y: 130 },
        { x: 125, y: 90}
      ]
      let dataPolygon = valSaved ? valSaved : {
        type: 'Polygon',
        type_detail: val,
        top: 50,
        left: 50,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        fill: this.colorFillCurr,
        stroke: this.colorFillCurr,
        strokeWidth: 1,
        objectCaching: false,
        transparentCorners: false,
        rx: 40, 
        ry: 80,
        ...this.handleConvertDimensions2PercentObj({top: 50, left: 50})
      }
      let ellipse = new fabric.Polygon(points, dataPolygon)
      this.handleAddNewAndTrigger(ellipse)
    },

    addLine (val, dashed = false, valSaved) {
      let dataLine = valSaved ? valSaved : {
        type: 'Line',
        type_detail: val,
        left: 150,
        top: 100,
        fill: this.colorFillCurr, 
        stroke: this.colorFillCurr, 
        strokeWidth: 2,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        ...this.handleConvertDimensions2PercentObj({top: 100, left: 150})
      }
      if (dashed) {
        dataLine['strokeDashArray'] = [5, 5]
      }
      let line = new fabric.Line([0, 20, 150, 20], dataLine)
      this.handleAddNewAndTrigger(line)
    },

    addArrowLine (val, dashed = false, arrow2 = false, valSaved){
      let triangle = new fabric.Triangle({
        type: 'Triangle',
        width: 10, 
        height: 15, 
        left: 200, 
        top: 65,
        angle: 90,
        fill: this.colorFillCurr, 
        stroke: this.colorFillCurr, 
        strokeWidth: 2,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true
      });

      let triangleFirst = new fabric.Triangle({
        type: 'Triangle',
        width: 10, 
        height: 15, 
        left: 60, 
        top: 77,
        angle: -90,
        fill: this.colorFillCurr, 
        stroke: this.colorFillCurr, 
        strokeWidth: 2,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true
      });

      let line = new fabric.Line([50, 100, 165, 100], {
        type: 'Line',
        type_detail: val,
        left: 75,
        top: 70,
        fill: this.colorFillCurr, 
        stroke: this.colorFillCurr, 
        strokeWidth: 2,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true
      });

      if (dashed) {
        line['strokeDashArray'] = [5, 5]
      }

      let objs = [line, triangle];
      if (arrow2) {
        objs.unshift(triangleFirst)
      }
      let dataGroup = valSaved ? valSaved : {
        type: 'Group',
        type_detail: 'line-arrow',
        left: 75,
        top: 70,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        ...this.handleConvertDimensions2PercentObj({top: 70, left: 75})
      }

      let alltogetherObj = new fabric.Group(objs, dataGroup);
      this.handleAddNewAndTrigger(alltogetherObj)
    },

    addLineCircle (val, dashed = false, valSaved) {
      let circleAfter = new fabric.Circle({
        type: 'Circle',
        width: 5, 
        height: 5, 
        left: 200, 
        top: 65,
        angle: 90,
        radius: 5,
        fill: this.colorFillCurr, 
        stroke: this.colorFillCurr, 
        strokeWidth: 2,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true
      });

      let circleBefore = new fabric.Circle({
        type: 'Circle',
        width: 5, 
        height: 5, 
        left: 50, 
        top: 77,
        angle: -90,
        radius: 5,
        fill: this.colorFillCurr, 
        stroke: this.colorFillCurr, 
        strokeWidth: 2,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true
      });

      let line = new fabric.Line([62, 100, 200, 100], {
        type: 'Line',
        type_detail: val,
        left: 55,
        top: 70,
        fill: this.colorFillCurr, 
        stroke: this.colorFillCurr, 
        strokeWidth: 2,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true
      });

      if (dashed) {
        line['strokeDashArray'] = [5, 5]
      }

      let objs = [circleBefore, line, circleAfter];
     
      let dataGroup = valSaved ? valSaved : {
        type: 'Group',
        type_detail: 'line-circle',
        left: 75,
        top: 70,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        ...this.handleConvertDimensions2PercentObj({top: 70, left: 75})
      }

      let alltogetherObj = new fabric.Group(objs, dataGroup);
      this.handleAddNewAndTrigger(alltogetherObj)
    },

    addArrowShape (val, deg = 0, arrow2 = false, valSaved) {
      let points = [
        { x: 140, y: 45 },
        { x: 200, y: 45 },
        { x: 200, y: 30},
        { x: 230, y: 58 },
        { x: 200, y: 85 },
        { x: 200, y: 70},
        { x: 140, y: 70}
      ]
      if (arrow2) {
        points = [...points, { x: 140, y: 85}, { x: 110, y: 58}, { x: 140, y: 30}, { x: 140, y: 45}]
      }
      let dataPolygon = valSaved ? valSaved : {
        type: 'Polygon',
        type_detail: val,
        position: this.slidesMain[this.slideIndexVisible].items.length,
        isNew: true,
        fill: this.colorFillCurr,
        stroke: this.colorFillCurr,
        strokeWidth: 1,
        objectCaching: false,
        transparentCorners: false,
        angle: deg
      }
      if (!valSaved) {
        switch(deg) {
          case 180:
            dataPolygon['top'] = 60
            dataPolygon['left'] = 100
            break;
          case -90:
            dataPolygon['top'] = 100
            dataPolygon['left'] = 50
            break;
          case 90:
            dataPolygon['top'] = 40
            dataPolygon['left'] = 65
            break;
          default:
            dataPolygon['top'] = 50
            dataPolygon['left'] = 50
            break;
        }
      }
      dataPolygon = {
        ...dataPolygon,
        ...this.handleConvertDimensions2PercentObj({top: dataPolygon.top, left: dataPolygon.left})
      }
      
      let ellipse = new fabric.Polygon(points, dataPolygon)
      this.handleAddNewAndTrigger(ellipse)
    },

    addImageUrl (imageUrl, options = null) {
      let self = this
      const optionReq = {
        crossOrigin: 'anonymous',
        type: KEY_PICTURE,
        type_detail: KEY_PICTURE,
        position: self.slidesMain[self.slideIndexVisible].items.length,
        ...this.handleConvertDimensions2PercentObj({top: 50, left: 50})
      }

      if (!options) {
        fabric.Image.fromURL(imageUrl, function(image) {
            const maxWidth = self.slideCurr.width / 2;
            const maxHeight = self.slideCurr.height / 2;
            let width = image.width;
            let height = image.height;
            if (image.width > maxWidth){
              width = maxWidth;
            }
            if (image.height > maxHeight){
              height = maxHeight;
            }
            image.set({ 'left': 50 });
            image.set({ 'top': 50 });
            image.scaleToWidth(width);
            image.scaleToHeight(height);
          
          self.handleAddNewAndTrigger(image)
        }, optionReq)
      } else {
        fabric.Image.fromURL(imageUrl, function(image) {
          image.set({...options})
          self.handleAddNewAndTrigger(image, options)
        }, { crossOrigin: 'anonymous' })
      }
    },

    addVideo: function (obj, saved = false) {
      let self = this

      let videoUrl = obj.video_src ? `${this.bookCdnUrl}${obj.video_src}` : obj.fileRef ? this.baseUrl + '/' + obj.fileRef : this.bookCdnUrl + obj.linkUrl;

      if (obj.file_uploaded) {
        videoUrl = `${self.baseUrl}/${obj.video_src}`
      }

      fabric.Image.fromURL(posterVideo, function(imageVideo) {
        if (!saved) {
          const maxWidth = 50;
          const maxHeight = 50;
          let width = imageVideo.width;
          let height = imageVideo.height;
          if (imageVideo.width > maxWidth){
            width = maxWidth;
          }
          if (imageVideo.height > maxHeight){
            height = maxHeight;
          }
          imageVideo.set({
            left: 10,
            top: 10,
            video_src: obj.fileRef ? obj.fileRef : obj.linkUrl,
            file_name: obj.name ? obj.name : obj.title,
            type: KEY_VIDEO,
            type_detail: KEY_VIDEO,
            file_uploaded: obj.fileRef ? true : false,
            position: self.slidesMain[self.slideIndexVisible].items.length,
            ...self.handleConvertDimensions2PercentObj({top: 10, left: 10})
          })
          imageVideo.scaleToWidth(width);
          imageVideo.scaleToHeight(height);
        } else {
          const { top, left, scaleX, scaleY } = obj
          imageVideo.set({...obj})
        }
        imageVideo.on('mousedblclick', function(e) {
          (obj.fileRef || obj.linkUrl || obj.video_src) && self.acSetLinkAudioVieoViewer(videoUrl)
        });
        self.handleAddNewAndTrigger(imageVideo, saved)
      }, { crossOrigin: 'anonymous' });
    },

    addAudio: function(obj, saved = false){
      let self = this
      let audioUrl = obj.audio_src ? `${this.bookCdnUrl}${obj.audio_src}` : obj.fileRef ? `${this.baseUrl}/${obj.fileRef}` : `${this.bookCdnUrl}${obj.linkUrl}`;
      if (obj.file_uploaded) {
        audioUrl = `${self.baseUrl}/${obj.audio_src}`
      }
      fabric.Image.fromURL(posterAudio, function(image) {
        if (!saved) {
          const maxWidth = 40;
          const maxHeight = 40;
          let width = image.width;
          let height = image.height;
          if (image.width > maxWidth){
            width = maxWidth;
          }
          if (image.height > maxHeight){
            height = maxHeight;
          }
          image.set({
            left: 10,
            top: 10,
            audio_src: obj.fileRef ? obj.fileRef : obj.linkUrl,
            file_name: obj.name ? obj.name : obj.title,
            type: KEY_AUDIO,
            type_detail: KEY_AUDIO,
            file_uploaded: obj.fileRef ? true : false,
            position: self.slidesMain[self.slideIndexVisible].items.length,
            ...self.handleConvertDimensions2PercentObj({top: 10, left: 10})
          })
          image.scaleToWidth(width);
          image.scaleToHeight(height);
        }  else {
          const { top, left, scaleX, scaleY } = obj
          image.set({
            top, left, scaleX, scaleY
          })
        }
        image.on('mousedblclick', function(e) {
          (obj.fileRef || obj.linkUrl || obj.audio_src) && self.acSetLinkAudioVieoViewer(audioUrl)
        });
        self.handleAddNewAndTrigger(image, saved)
      }, { crossOrigin: 'anonymous' });
    },

    saveMediaFile(data, hasCallback = true) {
      let self = this;
      fileService.save(data).then((response) => {
        if (response.data.status == 'success') {
          if (data.fileType === MEDIA_TYPE_IMG) {
            hasCallback && this.getImages();
            this.addImageUrl(this.baseUrl + "/" + response.data.data.fileRef)
          } else if (data.fileType === MEDIA_TYPE_VIDEO) {
            this.addVideo(response.data.data)
            hasCallback && this.getVideos()
          } else if (data.fileType === MEDIA_TYPE_AUDIO) {
            this.addAudio(response.data.data)
            hasCallback && this.getAudios()
          }
        }
      }).finally(() => self.setLoading(false));
    },

    handleAddNewAndTrigger (val, dataSaved = null) {
      !dataSaved && this.slidesMain[this.slideIndexVisible].items.push(val)
      this.slideCurr.add(val)
      
      this.slideCurr.renderAll().trigger('object:modified').trigger('selection:cleared')
      // this.slideCurr.renderAll()
      this.slidesMain[this.slideIndexVisible]['json'] = this.slideCurr.toJSON()
      // console.log('handle add elm: ', this.slidesMain, this.slidesMain[this.slideIndexVisible], this.slidesMain[this.slideIndexVisible + 1], this.slideIndexVisible)
      !dataSaved && this.acSetSlidesMain([...this.slidesMain])
      this.handleSaveCanvas()
    },
  }
}